// Shared, explicit email-format policy. HTML parsing is delegated to maintained sanitizers.
(function(root) {
    'use strict';
    const tags = 'div p span br hr h1 h2 h3 h4 h5 h6 strong b em i u s strike sub sup blockquote pre code ul ol li table thead tbody tfoot tr td th caption colgroup col a img font center'.split(' ');
    const attributes = {
        '*':['style','title','dir','lang'], a:['href','target','rel'], img:['src','alt','width','height'],
        table:['width','height','cellpadding','cellspacing','border','align','bgcolor','role'],
        td:['width','height','colspan','rowspan','align','valign','bgcolor'],
        th:['width','height','colspan','rowspan','align','valign','bgcolor','scope'],
        col:['width','span'], colgroup:['span'], ol:['start','type'], li:['value'], font:['color','face','size']
    };
    // No URL-bearing CSS, escapes, custom properties, positioning or selectors.
    const cssValue = /^(?!.*(?:url|expression|var|attr|image-set)\s*\()[a-zA-Z0-9#.,%()\s'"+-]+$/i;
    const properties = 'color background background-color font-family font-size font-weight font-style line-height letter-spacing text-align text-decoration text-transform vertical-align white-space word-break overflow-wrap width max-width min-width height max-height min-height margin margin-top margin-right margin-bottom margin-left padding padding-top padding-right padding-bottom padding-left border border-top border-right border-bottom border-left border-color border-width border-style border-radius border-collapse border-spacing box-sizing box-shadow display list-style-type'.split(' ');
    const styles = Object.fromEntries(properties.map(key=>[key,[cssValue]]));
    function safeUrl(value, image=false, variables=true) {
        if (typeof value !== 'string' || /[\u0000-\u0020\u007f\\<>"']/.test(value)) return false;
        if (!image && variables && value === '{{enlace}}') return true;
        if (/[{}]/.test(value)) return false;
        if (image && /^data:image\/(?:png|jpeg|gif|webp);base64,[A-Za-z0-9+/]+={0,2}$/.test(value)) return true;
        try {
            const url=new URL(value);
            if (url.username || url.password) return false;
            return image ? url.protocol==='https:' : ['https:','http:','mailto:','tel:'].includes(url.protocol);
        } catch { return false; }
    }
    function cleanStyle(value) {
        return String(value).split(';').map(part=>{
            const colon=part.indexOf(':'); if(colon<0)return '';
            const key=part.slice(0,colon).trim().toLowerCase(), val=part.slice(colon+1).trim();
            return Object.hasOwn(styles,key) && cssValue.test(val) ? key+':'+val : '';
        }).filter(Boolean).join(';');
    }
    const policy={tags,attributes,styles,safeUrl,cleanStyle,maxLength:100000};
    if(typeof module==='object' && module.exports)module.exports=policy;
    else root.EmailHtmlPolicy=policy;
})(typeof window==='undefined' ? globalThis : window);
